var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWxWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.63 102.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "blue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.81,102.38a3.61,3.61,0,0,1-3.6-3.6V85.87l-6.27,4.66a3.55,3.55,0,0,1-2.13.7,3.6,3.6,0,0,1-2.15-6.49l10.55-7.85V57.42L24.35,67.16,22.84,80.22a3.6,3.6,0,0,1-3.58,3.19,2.88,2.88,0,0,1-.41,0,3.6,3.6,0,0,1-3.17-4l.9-7.77L5.4,78.1a3.53,3.53,0,0,1-1.79.48A3.6,3.6,0,0,1,.12,74.05,3.58,3.58,0,0,1,1.8,71.87L13,65.41l-7.17-3.1a3.6,3.6,0,0,1,2.88-6.6l12.06,5.21,16.87-9.73L20.75,41.45,8.69,46.67a3.6,3.6,0,0,1-2.88-6.6L13,37,1.8,30.51A3.6,3.6,0,0,1,.12,28.33a3.6,3.6,0,0,1,3.49-4.54,3.57,3.57,0,0,1,1.79.49l11.18,6.45L15.68,23a3.6,3.6,0,0,1,3.17-4l.41,0a3.61,3.61,0,0,1,3.58,3.2l1.51,13.06L41.21,45V25.48L30.66,17.64a3.61,3.61,0,0,1-.75-5,3.62,3.62,0,0,1,5-.75l6.26,4.66V3.6a3.6,3.6,0,1,1,7.2,0V16.51l6.28-4.66a3.6,3.6,0,0,1,5,.76,3.6,3.6,0,0,1-.75,5L48.41,25.48V45l16.87-9.73,1.51-13.06A3.61,3.61,0,0,1,70.37,19l.41,0A3.6,3.6,0,0,1,74,23l-.9,7.76,11.18-6.45A3.54,3.54,0,0,1,86,23.79a3.6,3.6,0,0,1,3.12,1.8,3.6,3.6,0,0,1-1.31,4.92L76.65,37l7.17,3.1A3.6,3.6,0,0,1,82.38,47a3.57,3.57,0,0,1-1.44-.3L68.88,41.45,52,51.19l16.87,9.73,12.06-5.21a3.6,3.6,0,0,1,4.74,1.86,3.61,3.61,0,0,1-1.86,4.74l-7.17,3.1,11.18,6.46a3.6,3.6,0,0,1,1.31,4.91A3.6,3.6,0,0,1,86,78.58a3.51,3.51,0,0,1-1.79-.48L73.05,71.64l.9,7.77a3.6,3.6,0,0,1-3.17,4,2.88,2.88,0,0,1-.41,0,3.6,3.6,0,0,1-3.58-3.19L65.28,67.16,48.41,57.42V76.89L59,84.74a3.6,3.6,0,0,1,.75,5,3.57,3.57,0,0,1-2.9,1.46,3.61,3.61,0,0,1-2.14-.7l-6.27-4.66V98.78A3.6,3.6,0,0,1,44.81,102.38Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxWinter);
export default __webpack_public_path__ + "static/media/wxWinter.12f6aa124cb3b32b36ed3f654ce4c472.svg";
export { ForwardRef as ReactComponent };